import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import { BaseBackResponse } from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.repairer}quotes`;

export interface DeleteQuoteTaskCommandArgs {
  quoteId: string;
  repairerQuoteItemId: string;
}

export const deleteQuoteTaskRequest = (
  payload: DeleteQuoteTaskCommandArgs,
): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${payload.quoteId}/items`,
  config: {
    method: SUPPORTED_METHODS.DELETE,
    json: { repairerQuoteItemId: payload.repairerQuoteItemId },
  },
});

export const deleteQuoteTaskCommand = async (
  payload: DeleteQuoteTaskCommandArgs,
): Promise<BaseBackResponse> => {
  try {
    return await executeQuery<BaseBackResponse>(
      deleteQuoteTaskRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
